import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DialogContainerReadyService {
  private readySubject = new BehaviorSubject(false);

  ready$ = this.readySubject.pipe(filter(Boolean));

  setReady(isReady: boolean): void {
    this.readySubject.next(isReady);
  }
}
